export const Analytics = {
    userTiming: function userTiming(id, time)
    {
        const timeDiff = Date.now() - time;
        this.pushRaw({'event': 'custom-event-oap-timing', 'milliseconds': timeDiff, 'timinglabel': id});
    },
    push: function push (name, message = '')
    {
        this.pushRaw({'event': 'custom-event-oap', 'eventName' : name, 'eventMessage': message});
    },
    pushRaw: function (object) {
        try {
            /* Initialize GTM datalayer, if GTM has not yet done that */
            if (!window.dataLayer) {
                window.dataLayer = window.dataLayer || [];
            }
            window.dataLayer.push(object);
        } catch (err) {
        }
    }
};